import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { SharedModule } from 'OpsCenter/shared/shared.module';
import { BulkSettingsComponent } from './bulk-settings.component';

import { BulkSettingsService } from './bulk-settings.service';
@NgModule({
  imports: [HttpClientModule, CommonModule, SharedModule, FormsModule],
  declarations: [BulkSettingsComponent],
  providers: [BulkSettingsService],
  entryComponents: [BulkSettingsComponent],
})
export class BulkSettingsModule {
}



// WEBPACK FOOTER //
// ./src/app/ops-support/settings/bulk-settings.module.ts